import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ServiceConfigService } from '@app/services/service-config.service';

@Injectable()
export class AppStoreRedirectGuard implements CanActivate {

  readonly IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/tenncare/id1435791637';
  readonly ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=gov.tn.teds';
  // Native store schemes — open store apps directly without navigating the browser
  readonly IOS_STORE_SCHEME = 'itms-apps://apps.apple.com/us/app/tenncare/id1435791637';
  readonly ANDROID_STORE_SCHEME = 'market://details?id=gov.tn.teds';

  constructor(private serverConfig: ServiceConfigService) {}

  canActivate(): boolean {
    const config = this.serverConfig.getServerConfig();

    if (config.tccGetMobileAppSwitch) {
      const { isIOS, isAndroid } = this.detectPlatform();

      if (isIOS) {
        // Open App Store natively (browser stays on page), then navigate to root
        setTimeout(() => {
          window.location.href = this.IOS_STORE_SCHEME;
          setTimeout(() => { window.location.href = config.tccWebRootUrl || '/'; }, 100);
        });
        return false;
      }

      if (isAndroid) {
        // Open Play Store natively (browser stays on page), then navigate to root
        setTimeout(() => {
          window.location.href = this.ANDROID_STORE_SCHEME;
          setTimeout(() => { window.location.href = config.tccWebRootUrl || '/'; }, 100);
        });
        return false;
      }
    }

    // Not a mobile device or switch is off — stay on home page
    return false;
  }

  private detectPlatform(): { isIOS: boolean; isAndroid: boolean } {
    let isIOS = false;
    let isAndroid = false;

    if ((navigator as any).userAgentData) {
      const uaData = (navigator as any).userAgentData;
      isAndroid = uaData.platform === 'Android';
    }

    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (!isIOS) {
      isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

      if (!isIOS && /Macintosh/.test(userAgent)) {
        const hasTouch = 'ontouchend' in document;
        const hasTouchPoints = navigator.maxTouchPoints > 1;
        if (hasTouch && hasTouchPoints) {
          isIOS = true;
        }
      }
    }

    if (!isAndroid) {
      isAndroid = /android/i.test(userAgent);
    }

    return { isIOS, isAndroid };
  }
}
